// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminLegal = (client) => ({
    /**
     * `POST /admin/legal/policies`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalPoliciesCreate
     * @source apps/backend/src/api/admin/legal/policies/route.ts
     */
    createPolicy: (body, query, headers) => client.fetch("/admin/legal/policies", { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/legal/policies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalPoliciesIdDelete
     * @source apps/backend/src/api/admin/legal/policies/[id]/route.ts
     */
    deletePolicy: (id, body, query, headers) => client.fetch(buildPath("/admin/legal/policies/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/legal/platform-terms`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalPlatformTermsRetrieve
     * @source apps/backend/src/api/admin/legal/platform-terms/route.ts
     */
    listPlatformTerms: (query, headers) => client.fetch("/admin/legal/platform-terms", { method: "GET", query, headers }),
    /**
     * `GET /admin/legal/policies`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalPoliciesRetrieve
     * @source apps/backend/src/api/admin/legal/policies/route.ts
     */
    listPolicies: (query, headers) => client.fetch("/admin/legal/policies", { method: "GET", query, headers }),
    /**
     * `GET /admin/legal/products/:id/policies`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalProductsIdPoliciesRetrieve
     * @source apps/backend/src/api/admin/legal/products/[id]/policies/route.ts
     */
    listProductsPolicies: (id, query, headers) => client.fetch(buildPath("/admin/legal/products/:id/policies", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/legal/policies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalPoliciesIdRetrieve
     * @source apps/backend/src/api/admin/legal/policies/[id]/route.ts
     */
    retrievePolicy: (id, query, headers) => client.fetch(buildPath("/admin/legal/policies/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/legal/vendor-legal`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalVendorLegalRetrieve
     * @source apps/backend/src/api/admin/legal/vendor-legal/route.ts
     */
    retrieveVendorLegal: (query, headers) => client.fetch("/admin/legal/vendor-legal", { method: "GET", query, headers }),
    /**
     * `PUT /admin/legal/platform-terms`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalPlatformTermsPut
     * @source apps/backend/src/api/admin/legal/platform-terms/route.ts
     */
    updatePlatformTerm: (body, query, headers) => client.fetch("/admin/legal/platform-terms", { method: "PUT", body, query, headers }),
    /**
     * `POST /admin/legal/policies/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalPoliciesIdCreate
     * @source apps/backend/src/api/admin/legal/policies/[id]/route.ts
     */
    updatePolicy: (id, body, query, headers) => client.fetch(buildPath("/admin/legal/policies/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/legal/products/:id/policies/owner`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalProductsIdPoliciesOwnerCreate
     * @source apps/backend/src/api/admin/legal/products/[id]/policies/owner/route.ts
     */
    updateProductsPoliciesOwner: (id, body, query, headers) => client.fetch(buildPath("/admin/legal/products/:id/policies/owner", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/legal/products/:id/policies/seller-override`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalProductsIdPoliciesSellerOverrideCreate
     * @source apps/backend/src/api/admin/legal/products/[id]/policies/seller-override/route.ts
     */
    updateProductsPoliciesSellerOverride: (id, body, query, headers) => client.fetch(buildPath("/admin/legal/products/:id/policies/seller-override", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/legal/vendor-legal`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminLegalVendorLegalCreate
     * @source apps/backend/src/api/admin/legal/vendor-legal/route.ts
     */
    updateVendorLegal: (body, query, headers) => client.fetch("/admin/legal/vendor-legal", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=legal.js.map